@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package com.essntl.essntl_common.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val add: DrawableResource by 
      lazy { init_add() }

  public val add_image: DrawableResource by 
      lazy { init_add_image() }

  public val add_proposal_image: DrawableResource by 
      lazy { init_add_proposal_image() }

  public val add_square: DrawableResource by 
      lazy { init_add_square() }

  public val ai_essntl: DrawableResource by 
      lazy { init_ai_essntl() }

  public val arrange: DrawableResource by 
      lazy { init_arrange() }

  public val arrow_back: DrawableResource by 
      lazy { init_arrow_back() }

  public val arrow_down: DrawableResource by 
      lazy { init_arrow_down() }

  public val arrow_icon_down: DrawableResource by 
      lazy { init_arrow_icon_down() }

  public val arrow_icon_right: DrawableResource by 
      lazy { init_arrow_icon_right() }

  public val arrow_left: DrawableResource by 
      lazy { init_arrow_left() }

  public val arrow_right: DrawableResource by 
      lazy { init_arrow_right() }

  public val arrow_up: DrawableResource by 
      lazy { init_arrow_up() }

  public val attachment: DrawableResource by 
      lazy { init_attachment() }

  public val auth_mobile_picture: DrawableResource by 
      lazy { init_auth_mobile_picture() }

  public val auth_picture: DrawableResource by 
      lazy { init_auth_picture() }

  public val base_information: DrawableResource by 
      lazy { init_base_information() }

  public val be_logo_full_nude: DrawableResource by 
      lazy { init_be_logo_full_nude() }

  public val board: DrawableResource by 
      lazy { init_board() }

  public val board_icon: DrawableResource by 
      lazy { init_board_icon() }

  public val browse: DrawableResource by 
      lazy { init_browse() }

  public val calendar: DrawableResource by 
      lazy { init_calendar() }

  public val category: DrawableResource by 
      lazy { init_category() }

  public val check: DrawableResource by 
      lazy { init_check() }

  public val check_circle: DrawableResource by 
      lazy { init_check_circle() }

  public val clients: DrawableResource by 
      lazy { init_clients() }

  public val close: DrawableResource by 
      lazy { init_close() }

  public val close_circle: DrawableResource by 
      lazy { init_close_circle() }

  public val color_item: DrawableResource by 
      lazy { init_color_item() }

  public val concierge: DrawableResource by 
      lazy { init_concierge() }

  public val contact_icon: DrawableResource by 
      lazy { init_contact_icon() }

  public val copy: DrawableResource by 
      lazy { init_copy() }

  public val crm: DrawableResource by 
      lazy { init_crm() }

  public val crown: DrawableResource by 
      lazy { init_crown() }

  public val date: DrawableResource by 
      lazy { init_date() }

  public val dollar_square: DrawableResource by 
      lazy { init_dollar_square() }

  public val double_tick: DrawableResource by 
      lazy { init_double_tick() }

  public val download: DrawableResource by 
      lazy { init_download() }

  public val drag: DrawableResource by 
      lazy { init_drag() }

  public val edit: DrawableResource by 
      lazy { init_edit() }

  public val emoji_picker: DrawableResource by 
      lazy { init_emoji_picker() }

  public val empty_list: DrawableResource by 
      lazy { init_empty_list() }

  public val empty_search: DrawableResource by 
      lazy { init_empty_search() }

  public val expand: DrawableResource by 
      lazy { init_expand() }

  public val eye: DrawableResource by 
      lazy { init_eye() }

  public val file_picker: DrawableResource by 
      lazy { init_file_picker() }

  public val filter: DrawableResource by 
      lazy { init_filter() }

  public val first_time_image: DrawableResource by 
      lazy { init_first_time_image() }

  public val google: DrawableResource by 
      lazy { init_google() }

  public val group: DrawableResource by 
      lazy { init_group() }

  public val home: DrawableResource by 
      lazy { init_home() }

  public val info_circle: DrawableResource by 
      lazy { init_info_circle() }

  public val itinerary: DrawableResource by 
      lazy { init_itinerary() }

  public val link: DrawableResource by 
      lazy { init_link() }

  public val list: DrawableResource by 
      lazy { init_list() }

  public val list_bulleted: DrawableResource by 
      lazy { init_list_bulleted() }

  public val list_icon_request: DrawableResource by 
      lazy { init_list_icon_request() }

  public val list_numbered: DrawableResource by 
      lazy { init_list_numbered() }

  public val location: DrawableResource by 
      lazy { init_location() }

  public val logo: DrawableResource by 
      lazy { init_logo() }

  public val mail: DrawableResource by 
      lazy { init_mail() }

  public val map: DrawableResource by 
      lazy { init_map() }

  public val menu: DrawableResource by 
      lazy { init_menu() }

  public val messages: DrawableResource by 
      lazy { init_messages() }

  public val minus: DrawableResource by 
      lazy { init_minus() }

  public val more_horizontal: DrawableResource by 
      lazy { init_more_horizontal() }

  public val more_vertical: DrawableResource by 
      lazy { init_more_vertical() }

  public val note_favorite: DrawableResource by 
      lazy { init_note_favorite() }

  public val person: DrawableResource by 
      lazy { init_person() }

  public val phone: DrawableResource by 
      lazy { init_phone() }

  public val proposal: DrawableResource by 
      lazy { init_proposal() }

  public val publish: DrawableResource by 
      lazy { init_publish() }

  public val refresh: DrawableResource by 
      lazy { init_refresh() }

  public val request: DrawableResource by 
      lazy { init_request() }

  public val search: DrawableResource by 
      lazy { init_search() }

  public val search_image: DrawableResource by 
      lazy { init_search_image() }

  public val send: DrawableResource by 
      lazy { init_send() }

  public val service: DrawableResource by 
      lazy { init_service() }

  public val settings: DrawableResource by 
      lazy { init_settings() }

  public val share: DrawableResource by 
      lazy { init_share() }

  public val sms: DrawableResource by 
      lazy { init_sms() }

  public val sort: DrawableResource by 
      lazy { init_sort() }

  public val spinner_large: DrawableResource by 
      lazy { init_spinner_large() }

  public val spinner_medium: DrawableResource by 
      lazy { init_spinner_medium() }

  public val spinner_small: DrawableResource by 
      lazy { init_spinner_small() }

  public val star: DrawableResource by 
      lazy { init_star() }

  public val suppliers: DrawableResource by 
      lazy { init_suppliers() }

  public val task: DrawableResource by 
      lazy { init_task() }

  public val text_align_left: DrawableResource by 
      lazy { init_text_align_left() }

  public val text_bold: DrawableResource by 
      lazy { init_text_bold() }

  public val text_italic: DrawableResource by 
      lazy { init_text_italic() }

  public val text_strikethrough: DrawableResource by 
      lazy { init_text_strikethrough() }

  public val text_underline: DrawableResource by 
      lazy { init_text_underline() }

  public val tick: DrawableResource by 
      lazy { init_tick() }

  public val timer: DrawableResource by 
      lazy { init_timer() }

  public val trash: DrawableResource by 
      lazy { init_trash() }

  public val travelers: DrawableResource by 
      lazy { init_travelers() }

  public val user_avatar: DrawableResource by 
      lazy { init_user_avatar() }

  public val whatsapp: DrawableResource by 
      lazy { init_whatsapp() }

  public val world: DrawableResource by 
      lazy { init_world() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("add", CommonMainDrawable0.add)
  map.put("add_image", CommonMainDrawable0.add_image)
  map.put("add_proposal_image", CommonMainDrawable0.add_proposal_image)
  map.put("add_square", CommonMainDrawable0.add_square)
  map.put("ai_essntl", CommonMainDrawable0.ai_essntl)
  map.put("arrange", CommonMainDrawable0.arrange)
  map.put("arrow_back", CommonMainDrawable0.arrow_back)
  map.put("arrow_down", CommonMainDrawable0.arrow_down)
  map.put("arrow_icon_down", CommonMainDrawable0.arrow_icon_down)
  map.put("arrow_icon_right", CommonMainDrawable0.arrow_icon_right)
  map.put("arrow_left", CommonMainDrawable0.arrow_left)
  map.put("arrow_right", CommonMainDrawable0.arrow_right)
  map.put("arrow_up", CommonMainDrawable0.arrow_up)
  map.put("attachment", CommonMainDrawable0.attachment)
  map.put("auth_mobile_picture", CommonMainDrawable0.auth_mobile_picture)
  map.put("auth_picture", CommonMainDrawable0.auth_picture)
  map.put("base_information", CommonMainDrawable0.base_information)
  map.put("be_logo_full_nude", CommonMainDrawable0.be_logo_full_nude)
  map.put("board", CommonMainDrawable0.board)
  map.put("board_icon", CommonMainDrawable0.board_icon)
  map.put("browse", CommonMainDrawable0.browse)
  map.put("calendar", CommonMainDrawable0.calendar)
  map.put("category", CommonMainDrawable0.category)
  map.put("check", CommonMainDrawable0.check)
  map.put("check_circle", CommonMainDrawable0.check_circle)
  map.put("clients", CommonMainDrawable0.clients)
  map.put("close", CommonMainDrawable0.close)
  map.put("close_circle", CommonMainDrawable0.close_circle)
  map.put("color_item", CommonMainDrawable0.color_item)
  map.put("concierge", CommonMainDrawable0.concierge)
  map.put("contact_icon", CommonMainDrawable0.contact_icon)
  map.put("copy", CommonMainDrawable0.copy)
  map.put("crm", CommonMainDrawable0.crm)
  map.put("crown", CommonMainDrawable0.crown)
  map.put("date", CommonMainDrawable0.date)
  map.put("dollar_square", CommonMainDrawable0.dollar_square)
  map.put("double_tick", CommonMainDrawable0.double_tick)
  map.put("download", CommonMainDrawable0.download)
  map.put("drag", CommonMainDrawable0.drag)
  map.put("edit", CommonMainDrawable0.edit)
  map.put("emoji_picker", CommonMainDrawable0.emoji_picker)
  map.put("empty_list", CommonMainDrawable0.empty_list)
  map.put("empty_search", CommonMainDrawable0.empty_search)
  map.put("expand", CommonMainDrawable0.expand)
  map.put("eye", CommonMainDrawable0.eye)
  map.put("file_picker", CommonMainDrawable0.file_picker)
  map.put("filter", CommonMainDrawable0.filter)
  map.put("first_time_image", CommonMainDrawable0.first_time_image)
  map.put("google", CommonMainDrawable0.google)
  map.put("group", CommonMainDrawable0.group)
  map.put("home", CommonMainDrawable0.home)
  map.put("info_circle", CommonMainDrawable0.info_circle)
  map.put("itinerary", CommonMainDrawable0.itinerary)
  map.put("link", CommonMainDrawable0.link)
  map.put("list", CommonMainDrawable0.list)
  map.put("list_bulleted", CommonMainDrawable0.list_bulleted)
  map.put("list_icon_request", CommonMainDrawable0.list_icon_request)
  map.put("list_numbered", CommonMainDrawable0.list_numbered)
  map.put("location", CommonMainDrawable0.location)
  map.put("logo", CommonMainDrawable0.logo)
  map.put("mail", CommonMainDrawable0.mail)
  map.put("map", CommonMainDrawable0.map)
  map.put("menu", CommonMainDrawable0.menu)
  map.put("messages", CommonMainDrawable0.messages)
  map.put("minus", CommonMainDrawable0.minus)
  map.put("more_horizontal", CommonMainDrawable0.more_horizontal)
  map.put("more_vertical", CommonMainDrawable0.more_vertical)
  map.put("note_favorite", CommonMainDrawable0.note_favorite)
  map.put("person", CommonMainDrawable0.person)
  map.put("phone", CommonMainDrawable0.phone)
  map.put("proposal", CommonMainDrawable0.proposal)
  map.put("publish", CommonMainDrawable0.publish)
  map.put("refresh", CommonMainDrawable0.refresh)
  map.put("request", CommonMainDrawable0.request)
  map.put("search", CommonMainDrawable0.search)
  map.put("search_image", CommonMainDrawable0.search_image)
  map.put("send", CommonMainDrawable0.send)
  map.put("service", CommonMainDrawable0.service)
  map.put("settings", CommonMainDrawable0.settings)
  map.put("share", CommonMainDrawable0.share)
  map.put("sms", CommonMainDrawable0.sms)
  map.put("sort", CommonMainDrawable0.sort)
  map.put("spinner_large", CommonMainDrawable0.spinner_large)
  map.put("spinner_medium", CommonMainDrawable0.spinner_medium)
  map.put("spinner_small", CommonMainDrawable0.spinner_small)
  map.put("star", CommonMainDrawable0.star)
  map.put("suppliers", CommonMainDrawable0.suppliers)
  map.put("task", CommonMainDrawable0.task)
  map.put("text_align_left", CommonMainDrawable0.text_align_left)
  map.put("text_bold", CommonMainDrawable0.text_bold)
  map.put("text_italic", CommonMainDrawable0.text_italic)
  map.put("text_strikethrough", CommonMainDrawable0.text_strikethrough)
  map.put("text_underline", CommonMainDrawable0.text_underline)
  map.put("tick", CommonMainDrawable0.tick)
  map.put("timer", CommonMainDrawable0.timer)
  map.put("trash", CommonMainDrawable0.trash)
  map.put("travelers", CommonMainDrawable0.travelers)
  map.put("user_avatar", CommonMainDrawable0.user_avatar)
  map.put("whatsapp", CommonMainDrawable0.whatsapp)
  map.put("world", CommonMainDrawable0.world)
}

internal val Res.drawable.add: DrawableResource
  get() = CommonMainDrawable0.add

private fun init_add(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:add",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/add.xml", -1, -1),
    )
)

internal val Res.drawable.add_image: DrawableResource
  get() = CommonMainDrawable0.add_image

private fun init_add_image(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:add_image",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/add_image.xml", -1, -1),
    )
)

internal val Res.drawable.add_proposal_image: DrawableResource
  get() = CommonMainDrawable0.add_proposal_image

private fun init_add_proposal_image(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:add_proposal_image",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/add_proposal_image.xml", -1, -1),
    )
)

internal val Res.drawable.add_square: DrawableResource
  get() = CommonMainDrawable0.add_square

private fun init_add_square(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:add_square",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/add_square.svg", -1, -1),
    )
)

internal val Res.drawable.ai_essntl: DrawableResource
  get() = CommonMainDrawable0.ai_essntl

private fun init_ai_essntl(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ai_essntl",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/ai_essntl.png", -1, -1),
    )
)

internal val Res.drawable.arrange: DrawableResource
  get() = CommonMainDrawable0.arrange

private fun init_arrange(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrange",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrange.xml", -1, -1),
    )
)

internal val Res.drawable.arrow_back: DrawableResource
  get() = CommonMainDrawable0.arrow_back

private fun init_arrow_back(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_back",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrow_back.xml", -1, -1),
    )
)

internal val Res.drawable.arrow_down: DrawableResource
  get() = CommonMainDrawable0.arrow_down

private fun init_arrow_down(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_down",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrow_down.xml", -1, -1),
    )
)

internal val Res.drawable.arrow_icon_down: DrawableResource
  get() = CommonMainDrawable0.arrow_icon_down

private fun init_arrow_icon_down(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_icon_down",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrow_icon_down.xml", -1, -1),
    )
)

internal val Res.drawable.arrow_icon_right: DrawableResource
  get() = CommonMainDrawable0.arrow_icon_right

private fun init_arrow_icon_right(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_icon_right",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrow_icon_right.xml", -1, -1),
    )
)

internal val Res.drawable.arrow_left: DrawableResource
  get() = CommonMainDrawable0.arrow_left

private fun init_arrow_left(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_left",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrow_left.xml", -1, -1),
    )
)

internal val Res.drawable.arrow_right: DrawableResource
  get() = CommonMainDrawable0.arrow_right

private fun init_arrow_right(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_right",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrow_right.xml", -1, -1),
    )
)

internal val Res.drawable.arrow_up: DrawableResource
  get() = CommonMainDrawable0.arrow_up

private fun init_arrow_up(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:arrow_up",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/arrow_up.xml", -1, -1),
    )
)

internal val Res.drawable.attachment: DrawableResource
  get() = CommonMainDrawable0.attachment

private fun init_attachment(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:attachment",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/attachment.xml", -1, -1),
    )
)

internal val Res.drawable.auth_mobile_picture: DrawableResource
  get() = CommonMainDrawable0.auth_mobile_picture

private fun init_auth_mobile_picture(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:auth_mobile_picture",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/auth_mobile_picture.png", -1, -1),
    )
)

internal val Res.drawable.auth_picture: DrawableResource
  get() = CommonMainDrawable0.auth_picture

private fun init_auth_picture(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:auth_picture",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/auth_picture.png", -1, -1),
    )
)

internal val Res.drawable.base_information: DrawableResource
  get() = CommonMainDrawable0.base_information

private fun init_base_information(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:base_information",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/base_information.xml", -1, -1),
    )
)

internal val Res.drawable.be_logo_full_nude: DrawableResource
  get() = CommonMainDrawable0.be_logo_full_nude

private fun init_be_logo_full_nude(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:be_logo_full_nude",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/be_logo_full_nude.xml", -1, -1),
    )
)

internal val Res.drawable.board: DrawableResource
  get() = CommonMainDrawable0.board

private fun init_board(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:board",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/board.xml", -1, -1),
    )
)

internal val Res.drawable.board_icon: DrawableResource
  get() = CommonMainDrawable0.board_icon

private fun init_board_icon(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:board_icon",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/board_icon.xml", -1, -1),
    )
)

internal val Res.drawable.browse: DrawableResource
  get() = CommonMainDrawable0.browse

private fun init_browse(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:browse",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/browse.xml", -1, -1),
    )
)

internal val Res.drawable.calendar: DrawableResource
  get() = CommonMainDrawable0.calendar

private fun init_calendar(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:calendar",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/calendar.xml", -1, -1),
    )
)

internal val Res.drawable.category: DrawableResource
  get() = CommonMainDrawable0.category

private fun init_category(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:category",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/category.xml", -1, -1),
    )
)

internal val Res.drawable.check: DrawableResource
  get() = CommonMainDrawable0.check

private fun init_check(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:check",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/check.xml", -1, -1),
    )
)

internal val Res.drawable.check_circle: DrawableResource
  get() = CommonMainDrawable0.check_circle

private fun init_check_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:check_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/check_circle.xml", -1, -1),
    )
)

internal val Res.drawable.clients: DrawableResource
  get() = CommonMainDrawable0.clients

private fun init_clients(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:clients",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/clients.xml", -1, -1),
    )
)

internal val Res.drawable.close: DrawableResource
  get() = CommonMainDrawable0.close

private fun init_close(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:close",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/close.xml", -1, -1),
    )
)

internal val Res.drawable.close_circle: DrawableResource
  get() = CommonMainDrawable0.close_circle

private fun init_close_circle(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:close_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/close_circle.xml", -1, -1),
    )
)

internal val Res.drawable.color_item: DrawableResource
  get() = CommonMainDrawable0.color_item

private fun init_color_item(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:color_item",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/color_item.xml", -1, -1),
    )
)

internal val Res.drawable.concierge: DrawableResource
  get() = CommonMainDrawable0.concierge

private fun init_concierge(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:concierge",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/concierge.xml", -1, -1),
    )
)

internal val Res.drawable.contact_icon: DrawableResource
  get() = CommonMainDrawable0.contact_icon

private fun init_contact_icon(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:contact_icon",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/contact_icon.xml", -1, -1),
    )
)

internal val Res.drawable.copy: DrawableResource
  get() = CommonMainDrawable0.copy

private fun init_copy(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:copy",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/copy.xml", -1, -1),
    )
)

internal val Res.drawable.crm: DrawableResource
  get() = CommonMainDrawable0.crm

private fun init_crm(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:crm",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/crm.xml", -1, -1),
    )
)

internal val Res.drawable.crown: DrawableResource
  get() = CommonMainDrawable0.crown

private fun init_crown(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:crown",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/crown.xml", -1, -1),
    )
)

internal val Res.drawable.date: DrawableResource
  get() = CommonMainDrawable0.date

private fun init_date(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:date",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/date.xml", -1, -1),
    )
)

internal val Res.drawable.dollar_square: DrawableResource
  get() = CommonMainDrawable0.dollar_square

private fun init_dollar_square(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:dollar_square",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/dollar_square.xml", -1, -1),
    )
)

internal val Res.drawable.double_tick: DrawableResource
  get() = CommonMainDrawable0.double_tick

private fun init_double_tick(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:double_tick",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/double_tick.xml", -1, -1),
    )
)

internal val Res.drawable.download: DrawableResource
  get() = CommonMainDrawable0.download

private fun init_download(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:download",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/download.svg", -1, -1),
    )
)

internal val Res.drawable.drag: DrawableResource
  get() = CommonMainDrawable0.drag

private fun init_drag(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:drag",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/drag.xml", -1, -1),
    )
)

internal val Res.drawable.edit: DrawableResource
  get() = CommonMainDrawable0.edit

private fun init_edit(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:edit",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/edit.xml", -1, -1),
    )
)

internal val Res.drawable.emoji_picker: DrawableResource
  get() = CommonMainDrawable0.emoji_picker

private fun init_emoji_picker(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:emoji_picker",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/emoji_picker.xml", -1, -1),
    )
)

internal val Res.drawable.empty_list: DrawableResource
  get() = CommonMainDrawable0.empty_list

private fun init_empty_list(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:empty_list",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/empty_list.xml", -1, -1),
    )
)

internal val Res.drawable.empty_search: DrawableResource
  get() = CommonMainDrawable0.empty_search

private fun init_empty_search(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:empty_search",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/empty_search.xml", -1, -1),
    )
)

internal val Res.drawable.expand: DrawableResource
  get() = CommonMainDrawable0.expand

private fun init_expand(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:expand",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/expand.svg", -1, -1),
    )
)

internal val Res.drawable.eye: DrawableResource
  get() = CommonMainDrawable0.eye

private fun init_eye(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:eye",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/eye.xml", -1, -1),
    )
)

internal val Res.drawable.file_picker: DrawableResource
  get() = CommonMainDrawable0.file_picker

private fun init_file_picker(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:file_picker",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/file_picker.xml", -1, -1),
    )
)

internal val Res.drawable.filter: DrawableResource
  get() = CommonMainDrawable0.filter

private fun init_filter(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:filter",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/filter.xml", -1, -1),
    )
)

internal val Res.drawable.first_time_image: DrawableResource
  get() = CommonMainDrawable0.first_time_image

private fun init_first_time_image(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:first_time_image",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/first_time_image.png", -1, -1),
    )
)

internal val Res.drawable.google: DrawableResource
  get() = CommonMainDrawable0.google

private fun init_google(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:google",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/google.png", -1, -1),
    )
)

internal val Res.drawable.group: DrawableResource
  get() = CommonMainDrawable0.group

private fun init_group(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:group",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/group.xml", -1, -1),
    )
)

internal val Res.drawable.home: DrawableResource
  get() = CommonMainDrawable0.home

private fun init_home(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:home",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/home.xml", -1, -1),
    )
)

internal val Res.drawable.info_circle: DrawableResource
  get() = CommonMainDrawable0.info_circle

private fun init_info_circle(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:info_circle",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/info_circle.xml", -1, -1),
    )
)

internal val Res.drawable.itinerary: DrawableResource
  get() = CommonMainDrawable0.itinerary

private fun init_itinerary(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:itinerary",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/itinerary.xml", -1, -1),
    )
)

internal val Res.drawable.link: DrawableResource
  get() = CommonMainDrawable0.link

private fun init_link(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:link",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/link.xml", -1, -1),
    )
)

internal val Res.drawable.list: DrawableResource
  get() = CommonMainDrawable0.list

private fun init_list(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:list",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/list.xml", -1, -1),
    )
)

internal val Res.drawable.list_bulleted: DrawableResource
  get() = CommonMainDrawable0.list_bulleted

private fun init_list_bulleted(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:list_bulleted",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/list_bulleted.xml", -1, -1),
    )
)

internal val Res.drawable.list_icon_request: DrawableResource
  get() = CommonMainDrawable0.list_icon_request

private fun init_list_icon_request(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:list_icon_request",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/list_icon_request.xml", -1, -1),
    )
)

internal val Res.drawable.list_numbered: DrawableResource
  get() = CommonMainDrawable0.list_numbered

private fun init_list_numbered(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:list_numbered",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/list_numbered.xml", -1, -1),
    )
)

internal val Res.drawable.location: DrawableResource
  get() = CommonMainDrawable0.location

private fun init_location(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:location",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/location.xml", -1, -1),
    )
)

internal val Res.drawable.logo: DrawableResource
  get() = CommonMainDrawable0.logo

private fun init_logo(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/logo.xml", -1, -1),
    )
)

internal val Res.drawable.mail: DrawableResource
  get() = CommonMainDrawable0.mail

private fun init_mail(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:mail",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/mail.xml", -1, -1),
    )
)

internal val Res.drawable.map: DrawableResource
  get() = CommonMainDrawable0.map

private fun init_map(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:map",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/map.xml", -1, -1),
    )
)

internal val Res.drawable.menu: DrawableResource
  get() = CommonMainDrawable0.menu

private fun init_menu(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:menu",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/menu.xml", -1, -1),
    )
)

internal val Res.drawable.messages: DrawableResource
  get() = CommonMainDrawable0.messages

private fun init_messages(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:messages",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/messages.xml", -1, -1),
    )
)

internal val Res.drawable.minus: DrawableResource
  get() = CommonMainDrawable0.minus

private fun init_minus(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:minus",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/minus.xml", -1, -1),
    )
)

internal val Res.drawable.more_horizontal: DrawableResource
  get() = CommonMainDrawable0.more_horizontal

private fun init_more_horizontal(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:more_horizontal",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/more_horizontal.xml", -1, -1),
    )
)

internal val Res.drawable.more_vertical: DrawableResource
  get() = CommonMainDrawable0.more_vertical

private fun init_more_vertical(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:more_vertical",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/more_vertical.xml", -1, -1),
    )
)

internal val Res.drawable.note_favorite: DrawableResource
  get() = CommonMainDrawable0.note_favorite

private fun init_note_favorite(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:note_favorite",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/note_favorite.xml", -1, -1),
    )
)

internal val Res.drawable.person: DrawableResource
  get() = CommonMainDrawable0.person

private fun init_person(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:person",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/person.xml", -1, -1),
    )
)

internal val Res.drawable.phone: DrawableResource
  get() = CommonMainDrawable0.phone

private fun init_phone(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:phone",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/phone.xml", -1, -1),
    )
)

internal val Res.drawable.proposal: DrawableResource
  get() = CommonMainDrawable0.proposal

private fun init_proposal(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:proposal",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/proposal.xml", -1, -1),
    )
)

internal val Res.drawable.publish: DrawableResource
  get() = CommonMainDrawable0.publish

private fun init_publish(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:publish",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/publish.xml", -1, -1),
    )
)

internal val Res.drawable.refresh: DrawableResource
  get() = CommonMainDrawable0.refresh

private fun init_refresh(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:refresh",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/refresh.xml", -1, -1),
    )
)

internal val Res.drawable.request: DrawableResource
  get() = CommonMainDrawable0.request

private fun init_request(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:request",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/request.xml", -1, -1),
    )
)

internal val Res.drawable.search: DrawableResource
  get() = CommonMainDrawable0.search

private fun init_search(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:search",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/search.xml", -1, -1),
    )
)

internal val Res.drawable.search_image: DrawableResource
  get() = CommonMainDrawable0.search_image

private fun init_search_image(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:search_image",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/search_image.xml", -1, -1),
    )
)

internal val Res.drawable.send: DrawableResource
  get() = CommonMainDrawable0.send

private fun init_send(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:send",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/send.xml", -1, -1),
    )
)

internal val Res.drawable.service: DrawableResource
  get() = CommonMainDrawable0.service

private fun init_service(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:service",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/service.xml", -1, -1),
    )
)

internal val Res.drawable.settings: DrawableResource
  get() = CommonMainDrawable0.settings

private fun init_settings(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:settings",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/settings.xml", -1, -1),
    )
)

internal val Res.drawable.share: DrawableResource
  get() = CommonMainDrawable0.share

private fun init_share(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:share",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/share.xml", -1, -1),
    )
)

internal val Res.drawable.sms: DrawableResource
  get() = CommonMainDrawable0.sms

private fun init_sms(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sms",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/sms.xml", -1, -1),
    )
)

internal val Res.drawable.sort: DrawableResource
  get() = CommonMainDrawable0.sort

private fun init_sort(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:sort",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/sort.xml", -1, -1),
    )
)

internal val Res.drawable.spinner_large: DrawableResource
  get() = CommonMainDrawable0.spinner_large

private fun init_spinner_large(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:spinner_large",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/spinner_large.xml", -1, -1),
    )
)

internal val Res.drawable.spinner_medium: DrawableResource
  get() = CommonMainDrawable0.spinner_medium

private fun init_spinner_medium(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:spinner_medium",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/spinner_medium.xml", -1, -1),
    )
)

internal val Res.drawable.spinner_small: DrawableResource
  get() = CommonMainDrawable0.spinner_small

private fun init_spinner_small(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:spinner_small",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/spinner_small.xml", -1, -1),
    )
)

internal val Res.drawable.star: DrawableResource
  get() = CommonMainDrawable0.star

private fun init_star(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:star",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/star.xml", -1, -1),
    )
)

internal val Res.drawable.suppliers: DrawableResource
  get() = CommonMainDrawable0.suppliers

private fun init_suppliers(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:suppliers",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/suppliers.xml", -1, -1),
    )
)

internal val Res.drawable.task: DrawableResource
  get() = CommonMainDrawable0.task

private fun init_task(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:task",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/task.xml", -1, -1),
    )
)

internal val Res.drawable.text_align_left: DrawableResource
  get() = CommonMainDrawable0.text_align_left

private fun init_text_align_left(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:text_align_left",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/text_align_left.xml", -1, -1),
    )
)

internal val Res.drawable.text_bold: DrawableResource
  get() = CommonMainDrawable0.text_bold

private fun init_text_bold(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:text_bold",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/text_bold.xml", -1, -1),
    )
)

internal val Res.drawable.text_italic: DrawableResource
  get() = CommonMainDrawable0.text_italic

private fun init_text_italic(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:text_italic",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/text_italic.xml", -1, -1),
    )
)

internal val Res.drawable.text_strikethrough: DrawableResource
  get() = CommonMainDrawable0.text_strikethrough

private fun init_text_strikethrough(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:text_strikethrough",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/text_strikethrough.xml", -1, -1),
    )
)

internal val Res.drawable.text_underline: DrawableResource
  get() = CommonMainDrawable0.text_underline

private fun init_text_underline(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:text_underline",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/text_underline.xml", -1, -1),
    )
)

internal val Res.drawable.tick: DrawableResource
  get() = CommonMainDrawable0.tick

private fun init_tick(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:tick",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/tick.xml", -1, -1),
    )
)

internal val Res.drawable.timer: DrawableResource
  get() = CommonMainDrawable0.timer

private fun init_timer(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:timer",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/timer.xml", -1, -1),
    )
)

internal val Res.drawable.trash: DrawableResource
  get() = CommonMainDrawable0.trash

private fun init_trash(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:trash",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/trash.xml", -1, -1),
    )
)

internal val Res.drawable.travelers: DrawableResource
  get() = CommonMainDrawable0.travelers

private fun init_travelers(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:travelers",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/travelers.xml", -1, -1),
    )
)

internal val Res.drawable.user_avatar: DrawableResource
  get() = CommonMainDrawable0.user_avatar

private fun init_user_avatar(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:user_avatar",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/user_avatar.xml", -1, -1),
    )
)

internal val Res.drawable.whatsapp: DrawableResource
  get() = CommonMainDrawable0.whatsapp

private fun init_whatsapp(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:whatsapp",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/whatsapp.xml", -1, -1),
    )
)

internal val Res.drawable.world: DrawableResource
  get() = CommonMainDrawable0.world

private fun init_world(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:world",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/com.essntl.essntl_common.generated.resources/drawable/world.xml", -1, -1),
    )
)
